import { Trash2 } from "lucide-react";
import { useState } from "react";
import { Button } from "../ui/button";

function QuestionImg({
  id,
  src,
  alt,
  maxHeight = 1000,
  className = "",
  border = "",
  onImgDelete,
}: {
  id: string;
  src: string;
  alt: string;
  maxHeight?: number;
  className?: string;
  border?: string;
  onImgDelete?: () => void;
}) {
  const [imageKey, setImageKey] = useState(0); // Add a key state

  const handleImageError = () => {
    // Image failed to load, so let's attempt to reload it
    setImageKey(imageKey + 1); // Change the key to force a re-render
  };

  if (imageKey > 5 && src.indexOf("drive.google.com") > -1) {
    return (
      <a
        href={src}
        target="_blank"
        className="rounded-ea mx-auto"
        rel="noreferrer"
      >
        حدث خطأ في تحميل الصورة إضغط هنا
      </a>
    );
  }

  return (
    <div className="w-full h-fit relative">
      {onImgDelete !== undefined && <Button
        type="button"
        variant="destructive"
        className="absolute top-4 left-4"
        onClick={() => onImgDelete?.()}
      >
        <Trash2 className="size-4" />
      </Button>}
      <img
        id={id}
        width="100%"
        className={`w-full min-h-64 object-contain rounded-lg border ${className}`}
        style={{ maxHeight: maxHeight, border: border }}
        src={decodeURIComponent(src)}
        alt={alt}
        loading="lazy"
        onError={handleImageError}
        key={imageKey} // Use the key to force a re-render when needed
      />
    </div>
  );
}

export default QuestionImg;
